import { render } from "./P086.vue?vue&type=template&id=3c5c023c&scoped=true"
import script from "./P086.vue?vue&type=script&lang=js"
export * from "./P086.vue?vue&type=script&lang=js"

import "./P086.vue?vue&type=style&index=0&id=3c5c023c&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5c023c"]])

export default __exports__